import { AmortizacionReadingDtoProps } from "api/DTOs/AmortizacionReadingDto"
import { MovimientoBancarioReadingDtoProps } from "api/DTOs/MovimientoBancarioReadingDto"
import Modal from "common/components/Modal/Modal"
import NewAnnotationForm from "features/Contabilidad/pages/Prestamos/components/AnnotationForm/NewAnnotationForm"

import { useTranslation } from "react-i18next"

export const ModalNota = ({
  isOpen = false,
  data,
  handleSubmitAnnotation,
  onHide,
}: {
  isOpen: boolean
  data: MovimientoBancarioReadingDtoProps | AmortizacionReadingDtoProps | null
  handleSubmitAnnotation: (values: { descripcion: string }) => void
  onHide: () => void
}) => {
  const { t } = useTranslation()
  return (
    <Modal
      header={t("bancos.modal.headerNote")}
      visible={isOpen}
      onHide={onHide}
      size='small'
      draggable
    >
      <NewAnnotationForm
        data={data}
        onHide={onHide}
        handleSubmitAnnotation={handleSubmitAnnotation}
      />
    </Modal>
  )
}
